<template>
  <div class="shop-container">
    <div class="goods-swiper">
      <van-swipe class="goods-swipe" :autoplay="3000" :show-indicators="false" @change="onChange">
        <van-swipe-item v-for="(item, index) in goods.pictureCollection" :key="index" @click="preview(index)">
          <img :src="item + '?imageView2/1/w/750/h/750'">
        </van-swipe-item>
      </van-swipe>
      <div class="dots"><p v-for="index in goods.pictureCollection.length" :key="index" :style="{background: swiperIndex == index ? '#FFD133' : '#CCCCCC'}"></p></div>
    </div>
    <div class="goods-info">
      <div style="justify-content:space-between;display:flex;">
        <div class="price-box">
          <div class="s-price" v-if="goods.commodityStatus!=3">¥{{goods.discountPrice}}</div>
          <div class="goods-sq" v-else>已售罄</div>
          <div class="ph-price" v-if="goods.marketPrice&&goods.marketPrice>goods.discountPrice">市场价 <del>¥{{goods.marketPrice}}</del></div>
          <div class="dis" v-if="goods.marketPrice&&goods.marketPrice>goods.discountPrice">{{goods.discount}}</div>
        </div>
        <div class="chengse-box">
          <div class="cs">{{goods.commodityColor}}</div>
          <van-icon name="question-o" size="20px" color="#999" @click="checkCS" />
        </div>
      </div>
      <div class="goods-name">
        <i class="tag"><img src="@/assets/img/ziyi_icon.png" alt=""></i>{{ goods.brandName + goods.categoryName}}
      </div>
    </div>
    <div class="goods-serve mb24">
      <div class="goods-serve-title c999">服务</div>
      <div class="goods-serve-content">
        <span>泰康保真</span>
        <span class="dot">·</span>
        <span>专业鉴定</span>
        <span class="dot">·</span>
        <span>售后无忧</span>
      </div>
      <van-icon size="20px" name='weapp-nav' @click="checkServe" />
    </div>
    <div class="goods-params mb24">
      <div class="goods-item-title">商品参数</div>
      <div class="goods-params-content">
        <div class="params-table">
          <div class="item" v-for="(item,index) in goodsParameter" :key="index">
            <span>{{item.pname}}</span>
            <span class="w">{{item.pval}} <van-icon name="question-o" size="16px" @click="checkCS" color='#999' v-if="item.pname=='成色'" /></span>
          </div>
        </div>
      </div>
    </div>
    <div class="goods-tradeProcess mb24">
      <img src="@/assets/img/shop-process.png" alt=""  srcset=""> 
    </div>
    <div class="goods-detail">
      <div class="title">商品详情</div>
      <div class="content">
        <div class='item' v-for="thumb in goods.pictureCollection" :key="thumb">
          <img :src="thumb + '?imageView2/1/w/760/h/760'">
        </div>
      </div>
    </div>
    <div class="separator-box"></div>
    <div class="footer-box">
      <!-- <div class="button" @click="goHome">
        <div class="icon">
          <img src="@/assets/img/home_icon.png" alt="">
        </div>
        <span style="padding-top: .05rem;">首页</span>
      </div>
      <div class="button" @click="goOrder">
        <div class="icon">
          <img src="@/assets/img/shop_icon.png" alt="">
        </div>
        <span>我的订单</span>
      </div> -->
      <div class="btn-pay">
        <van-button round color="#DA3232" v-if="goods.commodityStatus!=3" block @click="createOrder">立即购买</van-button>
        <van-button round color="#282828" v-else block>已售罄</van-button>
      </div>
    </div>
    <!-- 服务说明 -->
    <action-sheet ref="actionSheetServe">
      <div class="goods-cs-wrapper">
        <div class="goods-cs-title fw ph-line">服务说明</div>
        <div class="goods-cs-content">
          <div class="goods-serve-item">
            <span class="label fw">
              <van-icon name="search" size="15px" color="#DA3232"/>泰康保真</span>
            <span class="describe">泰康保险】在胖虎购买并发货到用户手中的商品，经第三方或中检国检鉴定不是正品的，胖虎会给您办理退款并由泰康保险提供商品价格20%的赔款数。（需提供胖虎的防伪标签、鉴定证书）</span>
          </div>
          <div class="goods-serve-item">
            <span class="label fw">
               <van-icon name="search" size="15px" color="#DA3232"/>专业鉴定</span>
            <span class="describe">
               胖虎拥有强大的资深鉴定师团队，中国二手奢侈品行业协会专业鉴定委员会授权鉴定中心，中检奢侈品鉴定中心战略合作协议，《时尚芭莎》官方鉴定和售后服务合作伙伴。
            </span>
          </div>
          <div class="goods-serve-item">
            <span class="label fw">
               <van-icon name="search" size="15px" color="#DA3232"/>售后无忧</span>
            <span class="describe">
              因奢侈品属于贵重物品，故除商品真伪问题以外，不予退货。如需换货，请在收到货的48小时内联系客服。非质量问题，换货产生的邮费，由买家承担。如果对商品真伪存疑，请不要拆卸胖虎奢侈品正品保证防伪标签，可以联系客服进行第三方检验。
            </span>
          </div> 
        </div>
        <van-button class="tk_btn" type="info" size="large" @click="serveActionSheet">确认</van-button>
      </div>
    </action-sheet>
    <!-- 成色说明 -->
    <action-sheet ref="actionSheetCS">
      <div class="goods-cs-wrapper">
        <div class="goods-cs-title fw ph-line">成色说明</div>
        <div class="goods-cs-content" v-if="goods.primaryClassification!=1">
          <div class="goods-cs-item">
            <span class="label">99新(未使用): </span>
            <span class="describe">全新未使用，附件齐全(盒子、防尘、卡等)</span>
          </div>
          <div class="goods-cs-item">
            <span class="label">98新: </span>
            <span class="describe">
                商品未使用，附件缺失，或因陈列或存放产生的极细微的污渍、划痕等情况。
            </span>
          </div>
          <div class="goods-cs-item">
            <span class="label">95新: </span>
            <span class="describe">
              整体成色较新，金属类配件微氧化，轻微划痕、边角磨损但不明显，整体品相完整。
            </span>
          </div>
          <div class="goods-cs-item">
            <span class="label">9新: </span>
            <span class="describe">
              有日常使用痕迹，局部有少数划痕、污渍、五金轻微变色等情况，品相良好。
            </span>
          </div>
          <div class="goods-cs-item">
            <span class="label">85新: </span>
            <span class="describe">
              有明显使用痕迹，金属类氧化变色，边角磨损凸显，局部有明显划痕、污渍等，品相普通。
            </span>
          </div>
          <div class="goods-cs-item">
            <span class="label">8新: </span>
            <span class="describe">
              有长期使用痕迹，整体陈旧不洁，局部有较为严重的划痕、污渍、磨损等情况，品相较差但不影响正常使用。
            </span>
          </div>
        </div>
        <div class="goods-cs-content" v-if="goods.primaryClassification==1">
          <div class="goods-cs-item">
            <span class="label">99新(未使用)</span>
            <span class="describe">全新或者买回来以后没有用过，保存状态很好，配件齐全。</span>
          </div>
          <div class="goods-cs-item">
            <span class="label">98新</span>
            <span class="describe">
                手表因运输或存放以及陈列后产生轻微的痕迹，手表未使用但有长时间放置痕迹，整体状态很好，金属无磨损，皮带无破损，后盖无开启痕迹。手表功能状态良好，皮带有轻微折痕，手表边角有轻微划痕。
            </span>
          </div>
          <div class="goods-cs-item">
            <span class="label">95新</span>
            <span class="describe">
              有轻微的佩戴痕迹，边角有轻微的磨损，有划痕，皮带有佩戴过的弯折痕迹，表盘无水印，后盖未多次开启，只因正常保养开启后盖，皮表带轻微汗渍。或手表未使用过但有明显保存痕迹，但达不到98新级别。
            </span>
          </div>
          <div class="goods-cs-item">
            <span class="label">9新</span>
            <span class="describe">
              有使用痕迹，手表有磨损，有明显划痕，手表外壳以及表带有小磕伤，表盘无明显水印，后盖因保养开启，没有维修痕迹。皮带有深度折印（不好修复），皮带内汗渍较重，手表功能无损坏。
            </span>
          </div>
          <div class="goods-cs-item">
            <span class="label">85新</span>
            <span class="describe">
              有明显的使用痕迹，手表外观有明显磨损，深度划痕，外观有磕伤，表盘有轻微进水痕迹，表针表盘轻微氧化，机芯无大修痕迹，手表各功能无损坏，贵金属表壳有轻微氧化变色。皮带有破损，轻微裂皮。
            </span>
          </div>
          <div class="goods-cs-item">
            <span class="label">8新</span>
            <span class="describe">
              整体明显使用痕迹，手表整体使用磨损痕迹深而且明显，有少数较深磕伤。表针表盘并未整体氧化，有进水后水印，机芯大修但并未换件，手表基本功能未受损。贵金属表壳有明显变色痕迹，皮带开裂严重，折印开裂。
            </span>
          </div>
        </div>
        <van-button class="tk_btn" type="info" size="large" @click="cancelActionSheet">确认</van-button>
      </div>
    </action-sheet>
  </div>
</template>

<script>
import { BrowserInfo } from '@/utils'
import wxapi from '@/utils/wxApi'
import ActionSheet from '@/components/business/ActionSheet'
import { getSaleCommodityDetails, getGoodsParameter } from '@/api/good'
import { getWxUrl } from '@/api/order'
import { ImagePreview } from 'vant'

export default {
  components: {
    ActionSheet
  },
  data() {
    return {
      channel_id: '',
      goods_id: '',
      sale_id: '',
      goods: {
        pictureCollection: []
      },
      goodsParameter: [],
      swiperIndex: 1,
      custService: false,
      previewInstance: null
    }
  },
  created () {
    let bro = BrowserInfo()
    console.log(bro)
    this.goods_id = this.$route.params.gid;
    this.channel_id = this.$route.query.channel;
    this.sale_id = this.$route.query.sale;
    this.getGoods();
  },
  methods: {
    onChange(index) {
      this.swiperIndex = index + 1;
    },
    // 查看成色说明
    checkCS () {
      this.$refs.actionSheetCS.change()
    },
    cancelActionSheet () {
      this.$refs.actionSheetCS.change()
    },
    // 查看服务说明
    checkServe () {
      this.$refs.actionSheetServe.change()
    },
    serveActionSheet () {
      this.$refs.actionSheetServe.change()
    },
    // 创建订单
    createOrder() {
      // 清理结算缓存
      this.$store.dispatch('OnlineBalanceOut')
      let url = '/online/settlement/' + this.goods_id + '?channel='+this.channel_id+'&sale='+this.sale_id
      if (BrowserInfo().isWeixin) {
        getWxUrl({ url: url, label: 1 }).then(res => {
          location.href = res
        })
      } else {
        this.$router.push({ path: '/online/settlement/' + this.goods_id + '?channel='+this.channel_id+'&sale='+this.sale_id })
      }
    },
    // 商品预览
    preview (index) {
      this.previewInstance = ImagePreview({
        images: this.goods.pictureCollection,
        lazyLoad: true,
        startPosition: index
      })
    },
    // 首页
    goHome () {
      this.$router.push({ name:'home' })
    },
    goOrder() {
      if(this.$store.getters.token) {
        this.$router.push({ name: 'shopOrder' })
      } else {
        this.$router.push({ path: '/login?return_url=' + window.location.href })
      }
    },
    // 获取商品信息
    getGoods () {
      this.$toast.loading({
        mask: true,
        message: '加载中...'
      })
      getSaleCommodityDetails({ commodityId: this.goods_id, specialSaleId: this.sale_id }).then(res => {
        this.goods = res;
        getGoodsParameter({ commodityId: this.goods_id }).then(resq => {
          this.goodsParameter = resq
        }).catch(error => {
          console.log(error)
        })
        wxapi.wxRegister(this.wxRegCallback)
        this.$toast.clear()
      })
    },
    // 微信注册
    wxRegCallback () {
      // 微信分享
      this.wxShareTimeline()
      this.wxShareAppMessage()
    },
    wxShareTimeline () {
      let _this = this
      let option = {
        title: _this.goods.brandName + _this.goods.categoryName,
        link: process.env.VUE_APP_ROOT_URL + 'index.html#/online/goods/' + _this.goods_id + '?channel='+_this.channel_id+'&sale='+_this.sale_id,
        imgUrl: _this.goods.pictureCollection[0] + '?imageView2/1/w/300/h/300',
        success: () => {
          _this.$toast('分享成功')
        },
        error: () => {
          _this.$toast('已取消分享')
        }
      }
      // 将配置注入通用方法
      wxapi.ShareTimeline(option)
    },
    wxShareAppMessage () {
      let _this = this
      let option = {
        title: _this.goods.brandName + _this.goods.categoryName,
        desc: _this.goods.description,
        link: process.env.VUE_APP_ROOT_URL + 'index.html#/online/goods/' + _this.goods_id + '?channel='+_this.channel_id+'&sale='+_this.sale_id,
        imgUrl: _this.goods.pictureCollection[0] + '?imageView2/1/w/300/h/300',
        success: () => {
          _this.$toast('分享成功')
        },
        error: () => {
          _this.$toast('已取消分享')
        }
      }
      // 将配置注入通用方法
      wxapi.ShareAppMessage(option)
    }
  }
}
</script>

<style lang="less" scoped>
.goods-swiper {
  position: relative;
  height: 750px;
  .goods-swipe {
    img {
      width: auto;
      display: block;
      height: 750px;
      margin: 0 auto;
    }
  }
  .dots {
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: center;
    bottom: 32px;
    p {
      width: 16px;
      height: 16px;
      margin: 5px;
      border-radius: 50%;
    }
  }
}
.goods-info {
  background: #fff;
  margin-bottom: 24px;
  padding: 24px 24px;
  .price-box {
    display: flex;
    align-items: center;
    flex: 1;
    height: 88px;
    line-height: 88px;
    .s-price {
      font-size: 48px;
      font-weight: bold;
      color: #DA3232;
      margin-right: 16px;
    }
    .goods-sq {
      font-size: 48px;
      font-weight: bold;
      color: #282828;
      margin-right: 16px;
    }
    .ph-price {
      font-size: 24px;
      font-weight: 400;
      color: #999999;
      margin-right: 16px;
      del {
        text-decoration: line-through;
      }
    }
    .dis {
      font-size: 24px;
      color: #999999;
      font-weight: 500;
    }
  }
  .chengse-box {
    display: flex;
    align-items: center;
    height: 88px;
    line-height: 88px;
    .cs {
      font-size: 24px;
      margin-right: 10px;
      color: #282828;
      font-weight: 500;
    }
  }
  .goods-name {
    line-height: 40px;
    font-weight: 500;
    color: #000000;
    min-height: 36px;
    display: -webkit-box;
    display: -webkit-flex;
    display: table-cell;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    font-size: 32px;
    .tag {
      margin-right: 10px;
      height: 30px;
      line-height: 30px;
      display: inline-block;
      vertical-align: middle;
      margin-top: -6px;
      img {
        height: 30px;
        width: 90px;
        display: block;
      }
    }
  }
}
.goods-serve{
  background: #fff;
  font-size: 24px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  color: #282828;
  .goods-serve-content{
    flex: 1;
    padding: 24px;
    text-align: left;
    display: flex;
    align-items: center;
    .dot{
      height: 8px;
      line-height: 8px;
      color: #FFD133;
      font-size: 3em;
      margin: 0 14px;
    }
  }
}
.goods-params {
  background: #fff;
  font-size: 24px;
  padding: 0 24px 24px;
  text-align: left;
  .goods-item-title {
    font-size: 28px;
    font-weight: 400;
    color: #000000;
    padding: 25px 0 17px;
  }
  .goods-params-content {
    color: #282828;
    .params-table{
      display: table;
      width: 702px;
      border-collapse:collapse;
      .item{
        display: table-row;
        span{
          padding: 24px 28px;
          border: 1px solid #E5E5E5;
          display: table-cell;
          vertical-align: middle;
          width: 174px;
          .van-icon{
            vertical-align:text-top;
          }
        }
        span:last-child{
          user-select: all;
          -webkit-user-select: all;
        }
        .w { width: 525px; color: #333333;}
      }

    }
  }
}
.goods-tradeProcess{
  background: #fff;
  text-align: left;
  img{
    display: block;
    width: 100%;
  }
}
.goods-detail{
  background: #fff;
  font-size: 24px;
  padding: 0 24px 24px;
  text-align: left;
  .title {
    font-size: 28px;
    font-weight: 400;
    color: #000000;
    padding: 25px 0 17px;
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .item{
    img{
      display: block;
      width: 100%;
    }
  }
}
.separator-box {
  padding: 0px 90px;
  height: 115px;
}
.footer-box {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  box-sizing: content-box;
  height: 98px;
  background-color: #fff;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  .button {
    position: relative;
    display: flex;
    transition-duration: 0s;
    flex-direction: column;
    font-size: 20px;
    margin-left: 60px;
    .icon {
      position: relative;
      display: block;
      margin: 0;
      text-align: center;
      height: 50px;
      img {
        width: 44px;
        display: inline-block;
      }
    }
  }
  .btn-pay {
    display: flex;
    padding: 0 40px 0 40px;
    width: 100%;
    // margin-left: 40px;
  }
}
.van-button__text {
  font-size: 16px;
  font-weight: 500;
}

.goods-cs-wrapper {
  height: 770px !important;
}
.goods {
  &-cs-wrapper{
    font-size: 24px;
    text-align: left;
    color: #1B1B1B;
    height: 900px;
    .goods-cs-title{
      padding: 20px 24px;
      font-size: 32px;
      margin-bottom: 20px;
      position: fixed;
      width: 100%;
      background-color: #fff;
    }
    .goods-cs-content {
      padding: 100px 0;
    }
    .goods-cs-item{
      padding: 0 24px;
      display: flex;
      margin-bottom: 20px;
      .label{
        display: inline-block;
        flex-basis: 25%;
        font-size: 26px;
        font-weight: bold;
        // color: #1B1B1B;
      }
      .describe{
        font-size: 24px;
        color: #4C4C4C;
        line-height: 1.5;
        flex: 1;
      }
    }
    .goods-serve-item{
      padding: 0 24px;
      display: flex;
      flex-direction: column;
      margin-bottom: 20px;
      .label{
        display: inline-block;
        flex-basis: 25%;
        font-size: 26px;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        i{margin-right: 10px;}
      }
      .describe{
        font-size: 24px;
        color: #4C4C4C;
        line-height: 1.5;
        flex: 1;
      }
    }
  }
}
.action-btn {
  width: 100%;
  height: 100%;
  border: 0;
  background-color: transparent;
}
.tk_btn {
  position: fixed;
  bottom: 0;
  border-radius: inherit;
}
</style>


